import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import "../tokens.stylex.ts";
import { color, fontSize, fontWeight, lineHeight, media, radius, space } from "../tokens.stylex.ts";
import { surface } from "./surface.styles.ts";
export interface PanelProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  /** Remove body padding, e.g. for flush lists. */
  flush?: boolean;
  tone?: "default" | "danger";
}

/** A raised section. Use sparingly — whitespace separates most content. */
export function Panel({
  title,
  description,
  actions,
  footer,
  children,
  flush = false,
  tone = "default"
}: PanelProps) {
  return <section {...stylex.props(surface.raised, surface.md, styles.root, tone === "danger" && styles.danger)}>
      {title || actions ? <div className="x78zum5 x1cy8zhl x1qughib xpcbtbh x549ohs xsb4d8f x1lavhwh x18dy136">
          <div className="x78zum5 xdt5ytf x195vfkc xeuugli">
            {title ? <h2 {...{
          0: {
            className: "x1ghz6dp xluwven x1ivwu1z x9aqtqa"
          },
          1: {
            className: "x1ghz6dp xluwven x1ivwu1z x1xcodwn"
          }
        }[!!(tone === "danger") << 0]}>{title}</h2> : null}
            {description ? <div className="x1ghz6dp xket8oi x187ovcu x9tub0y">{description}</div> : null}
          </div>
          {actions ? <div className="x78zum5 x1a62zme x2lah0s">{actions}</div> : null}
        </div> : null}
      {children ? <div {...{
      0: {},
      1: {
        className: "x3eux3o xsb4d8f x1lavhwh"
      }
    }[!!!flush << 0]}>{children}</div> : null}
      {footer ? <div className="x78zum5 x6s0dn4 x1qughib x1a02dak xpcbtbh xk7tk9l xsb4d8f x1lavhwh x178xt8z x13fuv20 x8yrp0t x5rcijh xfcbtqh xvccuex xket8oi x187ovcu">{footer}</div> : null}
    </section>;
}
const styles = {
  root: {
    kaIpWk: "xlfxrz8",
    k7Eaqz: "xeuugli",
    $$css: true
  },
  danger: {
    "--face-bg": "x18d8edl",
    "--face-border": "x1raya8z",
    "--face-dot": "xyd7s8",
    "--slab-bg": "x1gpgqo3",
    "--slab-border": "xdr542g",
    $$css: true
  }
};